const prefix = '@subscription-manager';

const actionTypes = {
  SET_CURRENT_PACKAGE: `${prefix}/SET_CURRENT_PACKAGE`,
  SET_SUBSCRIPTIONS: `${prefix}/SET_SUBSCRIPTIONS`,
  SET_ECOMMERCE_PLANS: `${prefix}/SET_ECOMMERCE_PLANS`,
  SET_HOSTING_PACKAGES: `${prefix}/SET_HOSTING_PACKAGES`,
} as const;

export default actionTypes;
